<template>
	<div class="">
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="sa-container py-5 ">
			<div class="ftr-1-25 ftw600">
				{{$t('appointment.appointmentCourse')}}
			</div>
			<div class="d-flex flex-column align-items-center mt-3">
				<div class="appointment-main">
					<div class="d-flex align-items-center row justify-content-between">
						<div class="col-6">
							<div class="">
								{{$t('appointment.teacher')}}
							</div>
							<div class="border-gray br4 p-3 d-flex align-content-center">
								<img :src="userCoursePackage.photo_image" alt="" class="photo-40" />
								<div class="ml10">
									<div class="ftw600">{{userCoursePackage.name}}</div>
									<div class="cl-info ft14">
										{{userCoursePackage.status_text}}
									</div>
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="">
								<!-- 課堂包 -->
								{{$t('appointment.coursePackage')}}
							</div>
							<div class="border-gray br4 p-3 flex justify-content-between alcenter" style="height: 78px;">
								<div class="">
									<div class="cl-black">
										{{userCoursePackage.course_name}}({{$t('appointment.remainingClasses')}}:{{userCoursePackage.residue_quantity}})
									</div>
									<div class="cl-info">
										<!-- 预约截止日:2025年3月1日 -->
									</div>
								</div>
								<!-- <a-icon type="down"></a-icon> -->
							</div>
						</div>
					</div>
					<div class="mt-3" v-if="teacherTime.length!=0">
						<class-time @select="selectTime" :classTime="teacherTime" :maxNum="Number(userCoursePackage.residue_quantity)"></class-time>
					</div>
					<div class="mt-3">
						{{$t('appointment.selectedClasses')}}{{selectList.length}}堂，{{$t('appointment.availableClasses')}} {{Number(userCoursePackage.residue_quantity) - selectList.length}}堂
					</div>
					<div v-if="contactWay.length!=0">
						<div class="d-flex mt-4 justify-content-center border-b">
							<h5 class="ftw600">{{$t('appointment.contactTool')}}</h5>
						</div>
						<div class="mt-3 cl-info text-center">
							{{$t('appointment.selectContactTool')}}
						</div>
						<div class="mt-3 row justify-content-center">
							<div class="col-sm-4 d-flex  br4 justify-content-center py-3 clickAct"
								v-if="contactWay.includes('zoom')"
								@click="contact_way = 'zoom'"
								:class="contact_way=='zoom' ?'border-theme': 'border-gray' "
								:style="contact_way=='zoom' ? 'background-color: #F7FDFD;':''" >
								Zoom
							</div>
							<div class="col-sm-4 d-flex br4 justify-content-center py-3 ms-sm-3 mm-r-t"
							@click="contact_way = 'voov'"
							v-if="contactWay.includes('voov')"
							:class="contact_way=='voov' ?'border-theme': 'border-gray' "
								:style="contact_way=='voov' ? 'background-color: #F7FDFD;':''">
								Voov Heeting
							</div>
						</div>
					</div>
					
					<div class="mt-4 d-flex justify-content-center">
						<button type="button" class="btn btn-theme py-3 px-4" @click="showPopup">{{$t('appointment.nextStep')}}</button>
					</div>

				</div>
			</div>
		</div>
		<a-modal title="" :width="850" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null">
			<div class="d-flex alcenter">
				<img :src="userCoursePackage.photo_image" alt=""
					style="width: 70px;height: 70px;border-radius: 50%;" />
				<div class="ml15">
					<div class="ftr-1 ftw600 cl-black">
						{{userCoursePackage.name}}
					</div>
					<div class="ft14 cl-info">
						{{userCoursePackage.course_name}}
					</div>
					<div class="ft14 cl-info">
						{{$t('appointment.appointmentClass')}}：{{selectList.length}}
					</div>
				</div>
			</div>
			<!-- 添加表格 -->
			<table class="mt-3" style="width: 100%; border-collapse: collapse;">
				<thead>
					<tr>
						<th style="border: 1px solid #ccc; padding: 8px;">{{$t('appointment.classDate')}}</th>
						<th style="border: 1px solid #ccc; padding: 8px;">{{$t('appointment.time')}}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in selectList" :key="index">
						<td style="border: 1px solid #ccc; padding: 8px;">{{ item.date }}</td>
						<td style="border: 1px solid #ccc; padding: 8px;">{{formatTimeForDisplay( item.time.start,item.date) }} - {{formatTimeForDisplay( item.time.end,item.date)}}</td>
					</tr>
				</tbody>
			</table>
			<div class="mt-3 d-flex justify-content-center">
				<button type="button" class="btn btn-outline-gray px-4" @click="handleCancel">{{$t('common.cancel')}}</button>
				<button type="button" class="btn btn-theme px-4 ml15" @click="createOrder()">{{$t('common.confirm')}}</button>
			</div>
		</a-modal>
		<footers></footers>
	</div>
</template>

<script>
	import classTime from '../../components/teacher/classTime.vue';
	export default {
		components: {
			classTime
		},
		data() {
			return {
				currentDate: new Date(),
				weekStart: '',
				weekEnd: '',
				weekDays: [],
				isPopupVisible: false,
				selectedDate: '',
				selectedTime: '',
				popupTop: 0,
				popupLeft: 0,
				visible: false,
				user_course_package_id: 0,
				userCoursePackage: {},
				teacherTime: [],
				selectList: [],
				contact_way:'',
				contactWay:[],//可以用的聯係方式
				timeZone: localStorage.getItem('timeZone') || 'UTC'
			};
		},
		async created() {
			this.user_course_package_id = this.$route.query.id
			await this.preOrder()
		},
		methods: {
			handleCancel() {
				this.visible = false
			},
			
			async preOrder() {
				await this.$http.api('teacher/reservation/preOrder', {
					user_course_package_id: this.user_course_package_id
				}).then(res => {
					this.userCoursePackage = res.userCoursePackage
					this.teacherTime =  res.teacherTime
					this.contactWay = res.contactWay
				})
			},
			showPopup(){
				if(this.contact_way==''){
					this.$message.error(this.$t('appointment.selectContact'))
					return
				}
				this.visible = true
			},
			createOrder(){
				let arr = this.selectList.map(item=>{
					return{
						start_time:item.date+' ' +item.time.start,
						finish_time:item.date+' ' +item.time.end
					}
				})
				this.$http.api('teacher/reservation/createOrder', {
					user_course_package_id: this.user_course_package_id,
					contact_way:this.contact_way,
					reservation_list:arr
				}).then(res=>{
					this.$message.success(this.$t('appointment.reservationSuccess'),1,()=>{
						this.visible = false
						this.$router.push('/teacherIndex?tabIndex=1')
					})
				})
			},
			selectTime(e) {
				console.log("--------", e);
				this.selectList = e
			},
			formatTimeForDisplay(localTime, dateStr) {
				const [hour, minute] = localTime.split(':').map(Number);
				const baseDate = new Date(`${dateStr}T${localTime}:00`);
				const options = {
					hour: '2-digit',
					minute: '2-digit',
					hour12: false,
					timeZone: this.timeZone || 'UTC'
				};
				return new Intl.DateTimeFormat('en-GB', options).format(baseDate);
			},
		}
	};
</script>

<style scoped>
	.appointment-main {
		width: 700px;
	}

	@media (max-width:575.98px) {
		.appointment-main {
			width: 100%;
		}
	}

	.popup {
		position: absolute;
		background-color: white;
		padding: 10px 20px;
		border: 1px solid #ccc;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		z-index: 1000;
	}

	.list-unstyled {
		list-style: none;
		padding-left: 0;
	}

	.selected {
		color: #52C4C9;
		/* 主题色 */
		/* border: 1px solid #52C4C9; */
		border-radius: 4px;
	}

	.selectedBorder {
		border: 1px solid #52C4C9 !important;
	}

	@media (max-width:575.98px) {
		.sa-container {
			margin: auto;
			width: 100%;
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}

	}

	@media (min-width: 576px) {
		.sa-container {
			margin: auto;
			width: 580px;
		}

	}

	@media (min-width: 768px) {
		.sa-container {
			margin: auto;
			width: 700px;
		}
	}

	@media (min-width: 992px) {
		.sa-container {
			margin: auto;
			width: 900px;
		}
	}

	@media (min-width: 1200px) {
		.sa-container {
			margin: auto;
			width: 1100px;
		}
	}

	@media (min-width: 1400px) {
		.sa-container {
			margin: auto;
			width: 1300px;
		}
	}
</style>